import { fetchWithTokenRefresh } from './AuthActions';
import {
  comments_returned,
  comment_received,
  set_show_comments,
  set_show_delete_comment,
  comments_requested,
  comment_deleted,
  comment_updated
} from './types';
import env from '../globals/environment';
import socket from '../globals/socket';

export const listenForComments = () => {
  return async (dispatch, getState) => {
    const { usersStore } = getState();

    socket.on('comment', comment => {
      dispatch({
        type: comment_received,
        payload: {
          ...comment,
          sender: usersStore.users.filter(user => user._id === comment.sender_id)[0]
        }
      });
    });

    socket.on('comment-delete', id => {
      dispatch({
        type: comment_deleted,
        payload: id
      });
    });

    socket.on('comment-update', comment => {
      dispatch({
        type: comment_updated,
        payload: comment
      });
    });
  };
};

export const getComments = id => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { authStore, usersStore } = state;
      const { headers } = authStore;
      dispatch({ type: comments_requested });
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/comments/${id}`, { headers })(dispatch);

      if (!response.ok) throw new Error('Could not get comments from api');
      else {
        const comments = await response.json();

        dispatch({
          type: comments_returned,
          payload: comments.map(comment => ({
            ...comment,
            sender: usersStore.users.filter(user => user._id === comment.sender_id)[0]
          }))
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const sendComment = (shoutout_id, text) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { headers } = state.authStore;
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/comments`, {
        method: 'POST',
        body: JSON.stringify({
          shoutout_id,
          text
        }),
        headers
      })(dispatch);
      if (!response.ok) throw new Error('Could not get comments from api');
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteComment = (id) => {
  return async (dispatch, getState) => {
    try {
      const { headers } = getState().authStore;
      const response = await dispatch(fetchWithTokenRefresh(`${env.backendUrl}/comments/${id}`, { method: 'DELETE', headers }));
      if (!response.ok) throw new Error('Could not delete comment');
    } catch (error) {
      console.log(error);
    }
  };
};

export const setShowComments = (shoutout) => {
  return dispatch => {
    dispatch({ type: set_show_comments, payload: shoutout });
  };
};

export const setShowDeleteComment = (content) => {
  return { type: set_show_delete_comment, payload: content };
};


// WEBPACK FOOTER //
// ./src/actions/CommentsActions.js